<template>
  <section class="container mx-auto px-4 md:px-8 py-10 md:py-14">
    <h1 class="text-3xl md:text-4xl font-extrabold mb-6">Умови використання</h1>

    <div class="prose prose-neutral max-w-none">
      <h2>1. Загальні положення</h2>
      <p>Користуючись цим сайтом, ви погоджуєтесь з умовами нижче.</p>

      <h2>2. Замовлення та оплата</h2>
      <ul>
        <li>Ціни вказані у гривнях з урахуванням усіх податків.</li>
        <li>
          Оплата — онлайн/накладений платіж. Після оплати ви отримуєте
          підтвердження.
        </li>
      </ul>

      <h2>3. Доставка</h2>
      <p>Доставка Новою Поштою по Україні. Строки залежать від перевізника.</p>

      <h2>4. Повернення/обмін</h2>
      <p>
        Товари індивідуального користування
        <strong>не підлягають поверненню</strong>. Виняток — виробничий
        брак/помилка комплектації.
      </p>

      <h2>5. Інтелектуальна власність</h2>
      <p>
        Усі матеріали сайту належать їх правовласникам. Заборонено копіювання
        без згоди.
      </p>

      <h2>6. Відповідальність</h2>
      <p>
        Ми не несемо відповідальності за затримки з боку перевізників та
        сторонніх сервісів.
      </p>

      <h2>7. Зміни правил</h2>
      <p>
        Можемо оновлювати політики та умови. Актуальна версія публікується на
        цій сторінці.
      </p>

      <h2>8. Контакти</h2>
      <p>Питання — на сторінці <NuxtLink to="/contacts">Контакти</NuxtLink>.</p>

      <p class="text-sm text-gray-500 mt-8">Оновлено: {{ today }}</p>
    </div>
  </section>
</template>

<script setup>
const today = new Date().toLocaleDateString("uk-UA");
useHead({
  title: "Умови використання — mulberry’ss",
  meta: [
    {
      name: "description",
      content:
        "Правила користування сайтом, замовлення, оплата, доставка, повернення, права та відповідальність.",
    },
  ],
});
</script>
